import { useEffect, useState } from "react";
import { DayPicker } from "react-day-picker";
import { formattedLongUTC } from "../utils";
import Button from "../shared-components/Button";
import { format } from "date-fns";

function transformDateToLocalTimezone(date: Date) {
  const timeZone = format(new Date(), "z");
  const formatedDate = formattedLongUTC(date).replace("UTC", timeZone);
  return new Date(formatedDate);
}

function transformDateToUTCString(date: Date) {
  const timeZone = format(new Date(), "z");
  const newDate = format(date, `yyyy-MM-dd HH:mm:ss z`).replace(
    timeZone,
    "UTC"
  );
  return newDate;
}

export function ChangeDueDateContainer({
  selectedDate,
  createdAt,
  handleDueDateChange,
}: {
  selectedDate: Date;
  createdAt: Date;
  handleDueDateChange: (newDueDate: any) => Promise<void>;
}) {
  const [newDate, setNewDate] = useState(
    transformDateToLocalTimezone(selectedDate)
  );
  const [timeValue, setTimeValue] = useState(""); // New state variable
  useEffect(() => {
    const mins = String(newDate.getMinutes()).padStart(2, "0");
    const hours = String(newDate.getHours()).padStart(2, "0");
    setTimeValue(`${hours}:${mins}`);
  }, [newDate]);

  function updateNewDate(fulldate: Date, time?: string) {
    const pivotDate = new Date(newDate);
    pivotDate.setDate(fulldate.getDate());
    pivotDate.setMonth(fulldate.getMonth());
    pivotDate.setFullYear(fulldate.getFullYear());
    if (time) {
      const [hours, minutes] = time.split(":");
      pivotDate.setHours(+hours);
      pivotDate.setMinutes(+minutes);
    }
    setNewDate(pivotDate);
  }

  return (
    <>
      <div className="flex flex-col">
        <DayPicker
          mode="single"
          selected={newDate}
          onSelect={(e) => updateNewDate(e ?? new Date())}
          fromDate={createdAt}
          defaultMonth={newDate}
        />

        <div className="text-sm leading-4 font-medium text-gray-500">Time:</div>
        <div className="relative w-1/2">
          <input
            value={timeValue}
            step="600"
            onChange={(data) => {
              updateNewDate(newDate, data.currentTarget.value);
              setTimeValue(data.currentTarget.value);
            }}
            className="border rounded-lg p-3 w-full"
            type="time"
          />
        </div>
      </div>
      <div className="px-3 pt-3">
        <div className="py-2">
          Choosen Date:{" "}
          <span className="font-bold">{transformDateToUTCString(newDate)}</span>
        </div>
        <div className="flex justify-end">
          <Button
            text="Save"
            onClick={(e) => {
              e.preventDefault();
              handleDueDateChange(new Date(transformDateToUTCString(newDate)));
            }}
          />
        </div>
      </div>
    </>
  );
}
